import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { Meeting } from '@/types/meeting';
import * as api from '@/lib/api';

interface MeetingsState {
  items: Meeting[];
  selected: Meeting | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: MeetingsState = {
  items: [],
  selected: null,
  isLoading: false,
  error: null,
};

export const fetchMeetings = createAsyncThunk(
  'meetings/fetchAll',
  async (sport: number | undefined, { rejectWithValue }) => {
    try {
      const meetings = await api.getMeetings(sport);
      console.log('📋 Meetings loaded in Redux:', meetings);
      return meetings;
    } catch (error: any) {
      console.error('❌ Error in fetchMeetings:', error);
      // Если это пустой массив, не считаем это ошибкой
      if (Array.isArray(error) && error.length === 0) {
        return [];
      }
      return rejectWithValue(error.response?.data || error.message || 'Ошибка загрузки встреч');
    }
  }
);

export const fetchMeeting = createAsyncThunk(
  'meetings/fetchOne',
  async (id: number | string) => {
    const meeting = await api.getMeeting(id);
    return meeting;
  }
);

export const createMeetingThunk = createAsyncThunk(
  'meetings/create',
  async (data: any) => {
    const meeting = await api.createMeeting(data);
    return meeting;
  }
);

const meetingsSlice = createSlice({
  name: 'meetings',
  initialState,
  reducers: {
    setMeetings: (state, action: PayloadAction<Meeting[]>) => {
      state.items = action.payload;
    },
    setSelectedMeeting: (state, action: PayloadAction<Meeting | null>) => {
      state.selected = action.payload;
    },
    addMeeting: (state, action: PayloadAction<Meeting>) => {
      state.items.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMeetings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMeetings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(fetchMeetings.rejected, (state, action) => {
        state.isLoading = false;
        // Не устанавливаем ошибку, если это пустой массив или 401/404
        if (action.payload && typeof action.payload === 'string' && 
            (action.payload.includes('401') || action.payload.includes('404'))) {
          state.error = null;
          state.items = [];
        } else {
          state.error = action.error.message || 'Ошибка загрузки встреч';
        }
      })
      .addCase(fetchMeeting.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMeeting.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selected = action.payload;
      })
      .addCase(createMeetingThunk.fulfilled, (state, action) => {
        state.items.push(action.payload);
      });
  },
});

export const { setMeetings, setSelectedMeeting, addMeeting } =
  meetingsSlice.actions;
export default meetingsSlice.reducer;






